import React, { useState } from 'react';
import { Share2, Facebook, Copy, MessageCircle } from 'lucide-react';
import { navigate } from '../../App';

export function FloatingActionButtons({ isGuest, onCreateNew }) {
    const [open, setOpen] = useState(false);
    const shareUrl = encodeURIComponent(window.location.href);
    const shareText = encodeURIComponent(document.title);

    const handleCopy = () => {
        navigator.clipboard.writeText(window.location.href);
        alert('קישור הועתק!');
        setOpen(false);
    };

    const handleShareClick = () => setOpen((v) => !v);

    return (
        <div className="fixed bottom-20 right-6 z-50 flex flex-col items-end gap-2">
            {open && (
                <div className="flex flex-col items-end gap-2 mb-2 animate-fade-in">
                    <a
                        href={`https://wa.me/?text=${shareText}%20${shareUrl}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-10 h-10 rounded-full bg-success-500 text-white flex items-center justify-center shadow-elevated hover:scale-110 transition-all"
                        aria-label="שתף בוואטסאפ"
                        onClick={() => setOpen(false)}
                    >
                        <MessageCircle className="w-5 h-5" />
                    </a>
                    <a
                        href={`https://t.me/share/url?url=${shareUrl}&text=${shareText}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-10 h-10 rounded-full bg-info-500 text-white flex items-center justify-center shadow-elevated hover:scale-110 transition-all"
                        aria-label="שתף בטלגרם"
                        onClick={() => setOpen(false)}
                    >
                        <MessageCircle className="w-5 h-5" />
                    </a>
                    <a
                        href={`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="w-10 h-10 rounded-full bg-info-600 text-white flex items-center justify-center shadow-elevated hover:scale-110 transition-all"
                        aria-label="שתף בפייסבוק"
                        onClick={() => setOpen(false)}
                    >
                        <Facebook className="w-5 h-5" />
                    </a>
                    <button
                        onClick={handleCopy}
                        className="w-10 h-10 rounded-full bg-ink-subtle text-white flex items-center justify-center shadow-elevated hover:scale-110 transition-all"
                        aria-label="העתק קישור"
                    >
                        <Copy className="w-5 h-5" />
                    </button>
                </div>
            )}
            <button
                onClick={handleShareClick}
                className="w-12 h-12 rounded-full bg-gradient-to-br from-brand-500 to-brand-600 text-white shadow-elevated hover:shadow-hover transition-all duration-250 hover:scale-110 active:scale-95 flex items-center justify-center"
                aria-label="שתף"
            >
                <Share2 className="w-6 h-6" />
            </button>
        </div>
    );
}

export default FloatingActionButtons;
